import React from "react";
import { Text } from "@fluentui/react";
import { EMPTY_RESULTS } from "../../../../redux/constants/messageTypes";
import noContentIcon from "../../../../assets/svg/noSearchResults.svg";

const loaderBorderStyle = {
  padding: "10px auto",
  bottom: "50px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
};

const messageBorderStyle = {
  margin: "auto",
  width: "400px",
  paddingLeft: "0px",
};

const imageStyles = {
  width: 240,
  height: 240,
  objectFit: "contain",
  marginBottom: 16,
};

export function WorkingDocumentsNoDataDisplay() {
  return (
    <div style={loaderBorderStyle}>
      <div style={messageBorderStyle}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingBottom: "30px",
          }}
        />
        <Text
          variant="medium"
          styles={{
            root: {
              color: "#4c8d6a",
              fontFamily: "Poppins, sans-serif",
              fontWeight: 600,
              display: "block",
              width: "100%",
              textAlign: "center",
            },
          }}
        >
          {EMPTY_RESULTS}
        </Text>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            id="mainPageBackground"
            src={noContentIcon}
            style={imageStyles}
            alt="Welcome to Addovation Share"
          />
        </div>
      </div>
    </div>
  );
}
